// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"styles_modalTitle__198fk"};